module.exports = __webpack_public_path__ + "img/join_vip_1.75fea442.png";